const ensureError = (e: unknown): Error => (e instanceof Error ? e : new Error(String(e)));

export default ensureError;
